import { motion } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];

// Single scroll-reveal wrapper
export const Reveal = ({ children, delay = 0, y = 28, className, once = true }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once, margin: "-70px" }}
    transition={{ duration: 0.65, delay, ease: EASE }}
  >
    {children}
  </motion.div>
);

// 3D scroll-reveal (rotates up into place)
export const Reveal3D = ({ children, delay = 0, className, once = true }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y: 44, rotateX: 14 }}
    whileInView={{ opacity: 1, y: 0, rotateX: 0 }}
    viewport={{ once, margin: "-70px" }}
    transition={{ duration: 0.75, delay, ease: EASE }}
    style={{ transformPerspective: 1200 }}
  >
    {children}
  </motion.div>
);

// Stagger container + items
export const StaggerGroup = ({ children, className, delay = 0, gap = 0.09 }) => (
  <motion.div
    className={className}
    initial="hidden"
    whileInView="show"
    viewport={{ once: true, margin: "-70px" }}
    style={{ transformPerspective: 1200 }}
    variants={{ hidden: {}, show: { transition: { staggerChildren: gap, delayChildren: delay } } }}
  >
    {children}
  </motion.div>
);

export const StaggerItem = ({ children, className, y = 26 }) => (
  <motion.div
    className={className}
    variants={{
      hidden: { opacity: 0, y },
      show: { opacity: 1, y: 0, transition: { duration: 0.6, ease: EASE } },
    }}
  >
    {children}
  </motion.div>
);

export const StaggerItem3D = ({ children, className }) => (
  <motion.div
    className={className}
    style={{ transformPerspective: 1200 }}
    variants={{
      hidden: { opacity: 0, y: 40, rotateX: 16 },
      show: { opacity: 1, y: 0, rotateX: 0, transition: { duration: 0.7, ease: EASE } },
    }}
  >
    {children}
  </motion.div>
);

export default Reveal;
